import React from 'react';
import '../styles/Landing.css';
import Galaxy from './Galaxy';

const Landing = (props) => {

    return ( 
        <div className="landing">            
            <Galaxy />
        </div>
     );
}
 
export default Landing;